var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialPost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M5 21.75a1.81 1.81 0 0 1-.78-.18 1.74 1.74 0 0 1-1-1.57V3A1.76 1.76 0 0 1 5 1.25h14A1.76 1.76 0 0 1 20.75 3v17A1.75 1.75 0 0 1 18 21.4l-5.8-4.35a.24.24 0 0 0-.3 0L6.05 21.4a1.77 1.77 0 0 1-1.05.35zm0-19a.25.25 0 0 0-.25.25v17a.24.24 0 0 0 .14.22.23.23 0 0 0 .26 0L11 15.85a1.77 1.77 0 0 1 2.1 0l5.8 4.35a.23.23 0 0 0 .26 0 .24.24 0 0 0 .14-.22V3a.25.25 0 0 0-.3-.25z",
    opacity: 1,
    "data-original": "#232323",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M15 7.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPost);
export default __webpack_public_path__ + "static/media/social-post.0500436265450eb42506ba78306db17e.svg";
export { ForwardRef as ReactComponent };